// export const BASE_URL_V1 = "https://api.primetime-tournaments.com/" // todo:
import moment from "moment";

export const BASE_URL_V2 = "https://dummyjson.com"

export const WEB_ROUTES = {
    ACCOUNT: 'account',
    DASHBOARD: 'dashboard',
    USER_MANAGEMENT: 'user-management',
    LISTING_MANAGEMENT: 'listing-management',
    BOOKING_MANAGEMENT: 'booking-management',
    FAQ: "faq-management",
    SEND_NOTIFICATION: 'send-notification',
    SETTING: 'settings',
    GROUP_POST_MANAGEMENT: "group-post-management/:id",
    EVENT_POST_MANAGEMENT: "event-post-management/:id",
    PROFILE: "profile",
    HELP_AND_SUPPORT: "help-and-support",
    DISPUTE_MANAGEMENT: "dispute-management",
    DISPUTE_REASON: "dispute-reason",
}

export const LOCAL_STORAGE = {
    setUser: 'PTTUSER',
    setToken: 'PTTTOKEN',
}


export const BREAKPOINTS = {
    MOBILE: 991
}
export const apiUrl = {
    auth: 'auth',
    api: 'api',
    role: 'admin',
    user: 'user',
    login: 'login',
    forgotPass: 'forgot-password',
    changePass: 'change-password',

    // tournament
    tournament: 'tournament',
    livetournament: 'tournament/live',
    scheduletournament: 'tournament/schedule',
    ageGroup: 'age-group',
    refund: 'refund',
    startmatch: 'match/start',
    endmatch: 'match/end',
}


// DATA -> 
// DUMMY 
export const sportsStateList = [
    { value: 1, label: 'State 1' }, { value: 2, label: 'State 2' }, { value: 3, label: 'State 3' }];


export const sportsTypeList = [
    { value: 'Baseball', label: 'Baseball' }];


export const formateTTime = (dateStr) => {
    const date = new Date(dateStr);
    const options = { hour: 'numeric', minute: '2-digit', hour12: true };
    const timeFormatted = date.toLocaleString('en-US', options);
    return timeFormatted
}

export const formatedDate = (dateStr) => {
    const date = new Date(dateStr);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        // hour: 'numeric',
        // minute: '2-digit',
        // hour12: true
    };
    const dateFormatted = date.toLocaleString('en-US', options);
    return dateFormatted;
}

export const formatedDateTime = (dateStr) => {
    return moment(dateStr).format('MMMM Do YYYY, h:mm:ss a');
}